import React from "react";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import StatIcon from "@mui/icons-material/ShowChartOutlined";
import UsersIcon from "@mui/icons-material/PeopleAltOutlined";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import ServerIcon from "@mui/icons-material/Dns";
import Constants from "../../constants";

const navIndex = {
  "/app/home": 1,
  "/app/stat": 2,
  "/app/users": 3,
  "/app/servers": 5,
  "/logout": -1,
};

const userNavigations = [
  {
    name: "Home",
    path: "/app/home",
    tabIndex: 1,
    icon: <HomeIcon />,
  },
  {
    name: "Statistics",
    path: "/app/stat",
    tabIndex: 2,
    icon: <StatIcon />,
  },
  {
    name: "Servers",
    path: "/app/servers",
    tabIndex: 5,
    icon: <ServerIcon />,
  },
  {
    name: "",
    path: "/logout",
    tabIndex: -1,
    icon: <LogoutIcon />,
  },
];

const adminNavigations = [
  {
    name: "Home",
    path: "/app/home",
    tabIndex: 1,
    icon: <HomeIcon />,
  },
  {
    name: "Statistics",
    path: "/app/stat",
    tabIndex: 2,
    icon: <StatIcon />,
  },
  {
    name: "Servers",
    path: "/app/servers",
    tabIndex: 5,
    icon: <ServerIcon />,
  },
  {
    name: "Users",
    path: "/app/users",
    tabIndex: 3,
    icon: <UsersIcon />,
  },
  {
    name: "",
    path: "/logout",
    tabIndex: -1,
    icon: <LogoutIcon />,
  },
];

const superadminNavigations = [
  {
    name: "Home",
    path: "/app/home",
    tabIndex: 1,
    icon: <HomeIcon />,
  },
  {
    name: "Statistics",
    path: "/app/stat",
    tabIndex: 2,
    icon: <StatIcon />,
  },
  {
    name: "Servers",
    path: "/app/servers",
    tabIndex: 5,
    icon: <ServerIcon />,
  },
  {
    name: "Users",
    path: "/app/users",
    tabIndex: 3,
    icon: <UsersIcon />,
  },
  {
    name: "",
    path: "/logout",
    tabIndex: -1,
    icon: <LogoutIcon />,
  },
];


const getNavigationComponent = (user) => {
  const type = user["type"];
  if (type === Constants.user_type.USER) return userNavigations;
  if (type === Constants.user_type.ADMIN) return adminNavigations;
  return superadminNavigations;
};

export { navIndex };
export default getNavigationComponent;
